import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <AppSection />
        <UpdatesSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <FaqSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}